import React from 'react'

import './user-books-wrapper.styl'

export function UserSectionNavigationWrapper(props) {
  return <div className="user-section-navigation-wrapper">{props.children}</div>
}

export function UserSectionContentsWrapper(props) {
  return <div className="user-books-wrapper">{props.children}</div>
}
